import { Link } from 'react-router-dom';
import { Box, Button, Container, Group, Stack, Text, Title } from '@mantine/core';
import { IconBrandApple, IconBrandWindows, IconDownload } from '@tabler/icons-react';

import { Reveal } from '@/components/motion/Reveal';
import classes from './FinalCta.module.css';

export function FinalCta() {
  return (
    <Box component="section" id="final-cta" py={{ base: 80, md: 120 }} aria-labelledby="final-cta-title">
      <Container size="md">
        <Box className={classes.card}>
          <Stack align="center" ta="center" gap="md">
            <Reveal>
              <Title id="final-cta-title" order={2} className={classes.heading}>
                Ready to tune with{' '}
                <span className="tf-gradient-text">confidence?</span>
              </Title>
            </Reveal>
            <Reveal delay={0.05}>
              <Text c="var(--tf-text-secondary)" maw={520}>
                Download Clancy Tuning free for Windows or macOS. No credit card. No sign-up wall.
                Open the editor in under 60 seconds.
              </Text>
            </Reveal>
            <Reveal delay={0.1}>
              <Group gap="md" mt="md" justify="center" wrap="wrap">
                <Button
                  component={Link}
                  to="/download?platform=windows"
                  size="lg"
                  radius="md"
                  variant="gradient"
                  gradient={{ from: 'var(--tf-forge-start)', to: 'var(--tf-forge-end)', deg: 135 }}
                  leftSection={<IconBrandWindows size={20} />}
                  className={classes.cta}
                >
                  Download for Windows
                </Button>
                <Button
                  component={Link}
                  to="/download?platform=macos"
                  size="lg"
                  radius="md"
                  variant="default"
                  leftSection={<IconBrandApple size={20} />}
                  className={classes.ctaSecondary}
                >
                  Download for macOS
                </Button>
              </Group>
            </Reveal>
            <Reveal delay={0.2}>
              <Group gap="lg" mt="sm" justify="center">
                <Group gap={6} c="var(--tf-text-muted)">
                  <IconDownload size={14} />
                  <Text size="xs">Latest: v1.0.0</Text>
                </Group>
                <Text size="xs" c="var(--tf-text-muted)">
                  · Windows 10+ · macOS 12+
                </Text>
              </Group>
            </Reveal>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
